import { supabase } from "@/services/supabase/createClient";
import { useQuery } from "@tanstack/react-query";

export const getPublicConnectors = async () => {
  const { data, error } = await supabase.rpc("get_public_connectors");

  if (error) {
    throw error;
  }

  return data;
};

export const usePublicConnectors = () => {
  return useQuery({
    queryKey: ["publicConnectors"],
    queryFn: () => getPublicConnectors(),
    refetchOnWindowFocus: false,
  });
};
